
<div class="protocol-page">
  <header class="protocol-page-header">
    <div class="protocol-page-heading">
      <div class="protocol-page-heading-icon">
        <i class="pi pi-folder-open"></i>
      </div>

      <div class="protocol-page-heading-text">
        <h1>Gestione documenti e protocolli</h1>
        <p>
          Consulta, organizza e gestisci i documenti e i protocolli
          della Segreteria Provinciale.
        </p>
      </div>
    </div>

    <div class="protocol-page-header-actions">
      <p-button
        label="Carica documento"
        icon="pi pi-cloud-upload"
        styleClass="protocol-primary-button"
        (onClick)="openDocumentCreationDialog()"
      ></p-button>

      <p-button
        label="Nuovo protocollo"
        icon="pi pi-check-square"
        [outlined]="true"
        styleClass="protocol-secondary-button"
        (onClick)="generateNewProtocol()"
      ></p-button>
    </div>
  </header>

  <section class="protocol-content-card" [attr.aria-busy]="isLoading">
    <!-- Indicatore visibile sia all'apertura sia dopo il caricamento di un documento -->
    <div *ngIf="isLoading" class="protocol-loading-overlay" role="status" aria-live="polite">
      <div class="protocol-loading-content">
        <img src="assets/icons/loading-spinner.svg" alt="" class="protocol-loading-image" />
        <span>Caricamento documenti e protocolli in corso...</span>
      </div>
    </div>
    <p-tabView styleClass="protocol-tabs">

      <!-- DOCUMENTI -->

      <p-tabPanel header="Documenti">
        <p-table
          #dtDocuments
          styleClass="p-datatable-sm protocol-data-table protocol-documents-table"
          editMode="row"
          [value]="shownDocuments"
          [paginator]="true"
          [rows]="documentsPerPage"
          [first]="documentPageFirst"
          (onPage)="onDocumentsPage($event)"
          [globalFilterFields]="['name']"
          dataKey="docId"
        >
          <ng-template pTemplate="caption">
            <div class="protocol-table-toolbar">
              <div class="protocol-table-info">
                <div class="protocol-count-icon">
                  <i class="pi pi-file"></i>
                </div>

                <div class="protocol-table-count">
                  <strong>
                    {{ shownDocuments ? shownDocuments.length : 0 }}
                    documenti
                  </strong>
                  <span>Archivio documentale</span>
                </div>

                <div class="protocol-year-filter">
                  <label for="documentsYear">Anno</label>

                  <p-dropdown
                    inputId="documentsYear"
                    [(ngModel)]="selectedYear"
                    [options]="years"
                    (onChange)="onYearChange()"
                    styleClass="protocol-year-dropdown"
                  ></p-dropdown>
                </div>
              </div>

              <div class="protocol-table-tools">
                <div class="protocol-search">
                  <i class="pi pi-search"></i>

                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="searchD"
                    (ngModelChange)="onDocumentSearchChange(); dtDocuments.filterGlobal(searchD, 'contains')"
                    placeholder="Cerca un documento..."
                    aria-label="Cerca un documento"
                  />
                </div>

                <p-button
                  *ngIf="searchD !== ''"
                  icon="pi pi-filter-slash"
                  [outlined]="true"
                  pTooltip="Cancella ricerca"
                  tooltipPosition="top"
                  styleClass="protocol-tool-button"
                  (onClick)="searchD = ''; onDocumentSearchChange(); dtDocuments.filterGlobal(searchD, 'contains')"
                ></p-button>

                <p-button
                  icon="pi pi-refresh"
                  [outlined]="true"
                  pTooltip="Aggiorna documenti"
                  tooltipPosition="top"
                  styleClass="protocol-tool-button"
                  (onClick)="reloadAll()"
                ></p-button>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th class="protocol-actions-column">Azioni</th>

              <th
                pSortableColumn="name"
                class="protocol-name-column"
              >
                <span class="protocol-sort-header">
                  Nome documento
                  <p-sortIcon field="name"></p-sortIcon>
                </span>
              </th>

              <th
                pSortableColumn="mimeType"
                class="protocol-type-column"
              >
                <span class="protocol-sort-header">
                  Tipo
                  <p-sortIcon field="mimeType"></p-sortIcon>
                </span>
              </th>

              <th
                pSortableColumn="createdDate"
                class="protocol-date-column"
              >
                <span class="protocol-sort-header">
                  Creazione
                  <p-sortIcon field="createdDate"></p-sortIcon>
                </span>
              </th>

              <th
                pSortableColumn="modifiedDate"
                class="protocol-date-column"
              >
                <span class="protocol-sort-header">
                  Modifica
                  <p-sortIcon field="modifiedDate"></p-sortIcon>
                </span>
              </th>

              <th class="protocol-status-column">Firmato</th>
              <th class="protocol-status-column">Protocollato</th>
            </tr>
          </ng-template>

          <ng-template
            pTemplate="body"
            let-document
            let-editing="editing"
            let-ri="rowIndex"
          >
            <tr [pEditableRow]="document">
              <td>
                <div class="protocol-row-actions">
                  <p-button
                    *ngIf="!editing"
                    pRipple
                    pInitEditableRow
                    type="button"
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Modifica nome"
                    tooltipPosition="top"
                    styleClass="protocol-action-button"
                    (click)="onDocumentRowEditInit(document)"
                  ></p-button>

                  <p-button
                    *ngIf="!editing && !document.hasProtocol"
                    pRipple
                    type="button"
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Elimina documento"
                    tooltipPosition="top"
                    styleClass="protocol-action-button protocol-danger-action"
                    (click)="onDocumentDelete(document)"
                  ></p-button>

                  <p-button
                    *ngIf="!editing"
                    pRipple
                    type="button"
                    icon="pi pi-upload"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Gestione documento"
                    tooltipPosition="top"
                    styleClass="protocol-action-button"
                    (onClick)="openDocumentCreationDialog(document)"
                  ></p-button>

                  <p-button
                    *ngIf="!editing"
                    pRipple
                    type="button"
                    icon="pi pi-download"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Scarica documento"
                    tooltipPosition="top"
                    styleClass="protocol-action-button"
                    (onClick)="downloadFile(document)"
                  ></p-button>

                  <p-button
                    *ngIf="editing"
                    pRipple
                    pSaveEditableRow
                    type="button"
                    icon="pi pi-check"
                    [rounded]="true"
                    [text]="true"
                    severity="success"
                    pTooltip="Salva modifiche"
                    tooltipPosition="top"
                    styleClass="protocol-action-button"
                    (click)="onDocumentRowEditSave(document)"
                  ></p-button>

                  <p-button
                    *ngIf="editing"
                    pRipple
                    pCancelEditableRow
                    type="button"
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    pTooltip="Annulla modifica"
                    tooltipPosition="top"
                    styleClass="protocol-action-button"
                    (click)="onDocumentRowEditCancel(document, ri)"
                  ></p-button>
                </div>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="document.name"
                      class="protocol-name-input"
                    />
                  </ng-template>

                  <ng-template pTemplate="output">
                    <div class="protocol-document-cell">
                      <div class="protocol-file-icon">
                        <i class="pi pi-file-pdf"></i>
                      </div>

                      <p-button
                        [link]="true"
                        [label]="document.name"
                        styleClass="protocol-document-link"
                        [pTooltip]="document.name"
                        tooltipPosition="top"
                        (onClick)="previewFile(document)"
                      ></p-button>
                    </div>
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <span class="protocol-mime-type">
                  {{ document.mimeType }}
                </span>
              </td>

              <td>
                <span
                  class="protocol-date"
                  *ngIf="document.createdDate !== undefined"
                >
                  {{ document.createdDate | date: 'dd/MM/y' }}
                </span>
              </td>

              <td>
                <span
                  class="protocol-date"
                  *ngIf="document.modifiedDate !== undefined"
                >
                  {{ document.modifiedDate | date: 'dd/MM/y' }}
                </span>
              </td>

              <td class="protocol-status-cell">
                <p-tag
                  *ngIf="document.isSigned"
                  severity="success"
                  value="Sì"
                ></p-tag>

                <p-tag
                  *ngIf="!document.isSigned"
                  severity="warning"
                  value="No"
                ></p-tag>
              </td>

              <td class="protocol-status-cell">
                <p-tag
                  *ngIf="document.hasProtocol"
                  severity="success"
                  value="Sì"
                ></p-tag>

                <p-tag
                  *ngIf="!document.hasProtocol"
                  severity="warning"
                  value="No"
                ></p-tag>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">
                <div class="protocol-empty-state">
                  <i class="pi pi-folder-open"></i>
                  <strong>Nessun documento trovato</strong>
                  <span>
                    Non ci sono documenti per l'anno o la ricerca selezionati.
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Navigazione documenti: cinque elementi per pagina, senza scroll verticale -->
        <div class="protocol-documents-navigation" *ngIf="documentResultCount > 0" aria-label="Navigazione documenti">
          <button type="button" class="protocol-document-navigation-button"
            (click)="previousDocumentsPage()" [disabled]="documentPageFirst === 0"
            aria-label="Pagina documenti precedente">
            <i class="pi pi-chevron-left"></i><span>Precedente</span>
          </button>
          <span class="protocol-documents-page-indicator" aria-live="polite">
            {{ documentPageFirst + 1 }}–{{ documentPageEnd }} / {{ documentResultCount }}
          </span>
          <button type="button" class="protocol-document-navigation-button"
            (click)="nextDocumentsPage()" [disabled]="!canGoToNextDocumentsPage"
            aria-label="Pagina documenti successiva">
            <span>Successiva</span><i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </p-tabPanel>

      <!-- PROTOCOLLI -->

      <p-tabPanel header="Protocolli">
        <p-table
          #dtProtocols
          styleClass="p-datatable-sm protocol-data-table protocol-protocols-table"
          editMode="row"
          dataKey="protocolId"
          [paginator]="true"
          [rows]="protocolsPerPage"
          [first]="protocolPageFirst"
          (onPage)="onProtocolsPage($event)"
          [value]="shownProtocols"
          [scrollable]="true"
          scrollDirection="horizontal"
          [globalFilterFields]="['protocolId', 'document.name']"
        >
          <ng-template pTemplate="caption">
            <div class="protocol-table-toolbar">
              <div class="protocol-table-info">
                <div class="protocol-count-icon">
                  <i class="pi pi-verified"></i>
                </div>

                <div class="protocol-table-count">
                  <strong>
                    {{ shownProtocols ? shownProtocols.length : 0 }}
                    protocolli
                  </strong>
                  <span>Registro protocolli</span>
                </div>

                <div class="protocol-year-filter">
                  <label for="protocolsYear">Anno</label>

                  <p-dropdown
                    inputId="protocolsYear"
                    [(ngModel)]="selectedYear"
                    [options]="years"
                    (onChange)="onYearChange()"
                    styleClass="protocol-year-dropdown"
                  ></p-dropdown>
                </div>
              </div>

              <div class="protocol-table-tools">
                <div class="protocol-search">
                  <i class="pi pi-search"></i>

                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="searchP"
                    (ngModelChange)="onProtocolSearchChange(); dtProtocols.filterGlobal(searchP, 'contains')"
                    placeholder="Cerca un protocollo..."
                    aria-label="Cerca un protocollo"
                  />
                </div>

                <p-button
                  *ngIf="searchP !== ''"
                  icon="pi pi-filter-slash"
                  [outlined]="true"
                  pTooltip="Cancella ricerca"
                  tooltipPosition="top"
                  styleClass="protocol-tool-button"
                  (onClick)="searchP = ''; onProtocolSearchChange(); dtProtocols.filterGlobal(searchP, 'contains')"
                ></p-button>

                <p-button
                  icon="pi pi-refresh"
                  [outlined]="true"
                  pTooltip="Aggiorna protocolli"
                  tooltipPosition="top"
                  styleClass="protocol-tool-button"
                  (onClick)="reloadAll()"
                ></p-button>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th class="protocol-protocol-actions-column">Azioni</th>

              <th
                pSortableColumn="protocolId"
                class="protocol-progressive-column"
              >
                <span class="protocol-sort-header">
                  Progressivo
                  <p-sortIcon field="protocolId"></p-sortIcon>
                </span>
              </th>

              <th class="protocol-direction-column">
                Entrata / Uscita
              </th>

              <th
                pSortableColumn="document.name"
                class="protocol-name-column"
              >
                <span class="protocol-sort-header">
                  Nome documento
                  <p-sortIcon field="document.name"></p-sortIcon>
                </span>
              </th>
            </tr>
          </ng-template>

          <ng-template
            pTemplate="body"
            let-protocol
            let-ri="rowIndex"
          >
            <tr>
              <td>
                <div class="protocol-row-actions">
                  <p-button
                    *ngIf="protocol === latest"
                    pRipple
                    type="button"
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Elimina protocollo"
                    tooltipPosition="top"
                    styleClass="protocol-action-button protocol-danger-action"
                    (click)="onProtocolDelete(protocol)"
                  ></p-button>
                </div>
              </td>

              <td>
                <span class="protocol-progressive">
                  {{ protocol.protocolId }}
                </span>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-toggleButton
                      [ngModel]="protocol.type === InOutType.IN"
                      (onChange)="$event.checked ? protocol.type = InOutType.IN : protocol.type = InOutType.OUT"
                      onLabel="Entrata"
                      offLabel="Uscita"
                    ></p-toggleButton>
                  </ng-template>

                  <ng-template pTemplate="output">
                    <p-tag
                      *ngIf="protocol.type === InOutType.IN"
                      icon="pi pi-sign-in"
                      severity="info"
                      value="Entrata"
                    ></p-tag>

                    <p-tag
                      *ngIf="protocol.type === InOutType.OUT"
                      icon="pi pi-sign-out"
                      severity="info"
                      value="Uscita"
                    ></p-tag>
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <div class="protocol-document-cell">
                  <div class="protocol-file-icon">
                    <i class="pi pi-file"></i>
                  </div>

                  <span class="protocol-protocol-document-name" [pTooltip]="protocol.document.name" tooltipPosition="top">
                    {{ protocol.document.name }}
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4">
                <div class="protocol-empty-state">
                  <i class="pi pi-inbox"></i>
                  <strong>Nessun protocollo trovato</strong>
                  <span>
                    Non ci sono protocolli per l'anno o la ricerca selezionati.
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Cinque protocolli per pagina; nessuno scorrimento verticale -->
        <div class="protocol-documents-navigation" *ngIf="protocolResultCount > 0" aria-label="Navigazione protocolli">
          <button type="button" class="protocol-document-navigation-button"
            (click)="previousProtocolsPage()" [disabled]="protocolPageFirst === 0"
            aria-label="Pagina protocolli precedente">
            <i class="pi pi-chevron-left"></i><span>Precedente</span>
          </button>
          <span class="protocol-documents-page-indicator" aria-live="polite">
            {{ protocolPageFirst + 1 }}–{{ protocolPageEnd }} / {{ protocolResultCount }}
          </span>
          <button type="button" class="protocol-document-navigation-button"
            (click)="nextProtocolsPage()" [disabled]="!canGoToNextProtocolsPage"
            aria-label="Pagina protocolli successiva">
            <span>Successiva</span><i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </p-tabPanel>

    </p-tabView>
  </section>
</div>

<!-- DIALOG NUOVO PROTOCOLLO -->

<p-dialog
  header="Nuovo protocollo"
  [(visible)]="protocolGeneration"
  [closable]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: 'min(720px, 95vw)' }"
  styleClass="protocol-generation-dialog"
  (onHide)="closeProtocolGeneration()"
>
  <div class="protocol-dialog-description">
    <i class="pi pi-info-circle"></i>
    <span>
      Seleziona il documento da protocollare e specifica
      se si tratta di un protocollo in entrata o in uscita.
    </span>
  </div>

  <p-table
    styleClass="p-datatable-sm protocol-selection-table"
    [value]="protocolableDocuments"
    [scrollable]="true"
    selectionMode="single"
    [(selection)]="selectedProtocolable"
    scrollDirection="horizontal"
    dataKey="docId"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          <span class="protocol-sort-header">
            Nome documento
            <p-sortIcon field="name"></p-sortIcon>
          </span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-document>
      <tr [pSelectableRow]="document">
        <td>
          <div class="protocol-document-cell">
            <div class="protocol-file-icon">
              <i class="pi pi-file-pdf"></i>
            </div>

            <span class="protocol-selection-document-name">
              {{ document.name }}
            </span>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td>
          <div class="protocol-empty-state">
            <i class="pi pi-check-circle"></i>
            <strong>Nessun documento da protocollare</strong>
            <span>
              Tutti i documenti disponibili risultano già protocollati.
            </span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="protocol-dialog-direction">
    <span>Tipo di protocollo</span>

    <p-toggleButton
      [(ngModel)]="isOut"
      onLabel="Uscita"
      offLabel="Entrata"
      onIcon="pi pi-sign-out"
      offIcon="pi pi-sign-in"
    ></p-toggleButton>
  </div>

  <ng-template pTemplate="footer">
    <div class="protocol-dialog-footer">
      <p-button
        label="Conferma"
        icon="pi pi-check"
        [disabled]="!selectedProtocolable"
        (onClick)="confirm()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- ANTEPRIMA PDF -->

<p-dialog
  header="Visualizza documento"
  [(visible)]="showPreview"
  [style]="{
    width: '96vw',
    height: '94vh'
  }"
  [draggable]="false"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  styleClass="protocol-preview-dialog"
  (onHide)="closePreview()"
>
  <div class="protocol-preview-content">
    <ngx-extended-pdf-viewer
      *ngIf="fileSrc"
      [enablePrint]="false"
      [showToolbar]="false"
      [enableDragAndDrop]="false"
      [handTool]="false"
      [src]="fileSrc"
    ></ngx-extended-pdf-viewer>
  </div>
</p-dialog>
